import type { FeatureCheckOptions } from "@/App/user/featureCheckOptions";

const userHasFeature = ({ user, feature, organizationId }: FeatureCheckOptions): boolean => {
  if (!user?.features) return false;

  return user.features.some((f) => {
    if (f.name !== feature || !f.enabled) return false;
    if (organizationId) {
      return f.grantedBy?.some((entity) => entity.id === organizationId);
    }
    return true;
  });
};

export const userHasFeatureEnabled = ({ user, feature }: FeatureCheckOptions): boolean => {
  return userHasFeature({ user, feature });
};

export const userHasFeatureForOrganization = ({ user, feature, organizationId }: FeatureCheckOptions): boolean => {
  if (!organizationId) return false;
  return userHasFeature({ user, feature, organizationId });
};
